function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "search");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home",
  transform: "translate(-320.000000, -121.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "search",
  transform: "translate(320.000000, 121.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.9432149,12.26403 C14.8781825,10.9872409 15.4374309,9.41894075 15.4374309,7.71877879 C15.4374309,3.46279058 11.9746605,0 7.71869702,0 C3.46273358,0 0,3.46279058 0,7.71877879 C0,11.974767 3.46277044,15.4375576 7.71873388,15.4375576 C9.41888594,15.4375576 10.9873244,14.8782322 12.2641061,13.9432592 L17.3208174,19 L19,17.3208077 C19,17.3207708 13.9432149,12.26403 13.9432149,12.26403 L13.9432149,12.26403 Z M7.71873388,13.0625346 C4.77201983,13.0625346 2.37500921,10.66551 2.37500921,7.71877879 C2.37500921,4.7720476 4.77201983,2.37502303 7.71873388,2.37502303 C10.6654479,2.37502303 13.0624585,4.7720476 13.0624585,7.71877879 C13.0624585,10.66551 10.6654111,13.0625346 7.71873388,13.0625346 Z",
  id: "Shape"
}))));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.169b456b.svg";
export { ForwardRef as ReactComponent };